<template>
  <div class="homeContent">
    <img src="../../assets/home.jpg" style="width: 100%; height: 100%" alt="" srcset="">
  </div>
</template>

<script>
  export default {
    name: "Home",
    components: {},
    mounted() {
      this.checkLogin();
    },
    methods: {
      checkLogin() {
        this.$http.get("basic", "account/checkLogin");
      },
    },
  };
</script>

<style lang="scss" scoped>
.vm-content,
.homeContent {
  height: 100%;
  padding: 0 !important;
  border-radius: 3px;
  overflow: hidden;
}
</style>
